var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTWMergeContext } from '@marketing/TWMergeContext';
import { clsx } from 'clsx';
import { Children, useRef, useState } from 'react';
import { useSwipeable } from 'react-swipeable';
import Controls from './Controls';
function Carousel(_a) {
    var _b;
    var children = _a.children, _c = _a.hideOverflow, hideOverflow = _c === void 0 ? true : _c, _d = _a.controlsPadding, controlsPadding = _d === void 0 ? '' : _d, _e = _a.alignItemsClassName, alignItemsClassName = _e === void 0 ? 'items-end' : _e, onSelectIndex = _a.onSelectIndex, _f = _a.controlsInsideContent, controlsInsideContent = _f === void 0 ? false : _f, childWidth = _a.childWidth, _g = _a.theme, theme = _g === void 0 ? 'dark' : _g, _h = _a.gap, gap = _h === void 0 ? 0 : _h;
    var twMerge = useTWMergeContext().twMerge;
    var _j = useState(0), selectedIndex = _j[0], setSelectedIndex = _j[1];
    var sliderRef = useRef(null);
    var slideDistance = gap + (childWidth ? childWidth : ((_b = sliderRef.current) === null || _b === void 0 ? void 0 : _b.clientWidth) || 0);
    var handlers = useSwipeable({
        onSwipedLeft: function () {
            // Circular navigation: wrap to first item when swiping past last
            var newIndex = (selectedIndex + 1) % Children.count(children);
            setSelectedIndex(newIndex);
            if (onSelectIndex) {
                onSelectIndex(newIndex);
            }
        },
        onSwipedRight: function () {
            // Circular navigation: wrap to last item when swiping before first
            var newIndex = (selectedIndex - 1 + Children.count(children)) % Children.count(children);
            setSelectedIndex(newIndex);
            if (onSelectIndex) {
                onSelectIndex(newIndex);
            }
        },
        swipeDuration: 500,
        preventScrollOnSwipe: true,
        trackMouse: false,
    });
    return (_jsxs("div", __assign({ className: clsx('relative w-full h-full flex flex-col justify-end', hideOverflow ? 'overflow-hidden' : '') }, handlers, { children: [_jsx("div", __assign({ style: {
                    transform: "translateX(".concat(slideDistance * -selectedIndex, "px)"),
                    transition: 'transform 0.5s',
                    columnGap: "".concat(gap, "px"),
                }, ref: sliderRef, className: clsx('flex justify-start items-stretch h-full w-full', alignItemsClassName) }, { children: Children.map(children, function (child, index) {
                    return (_jsx("div", __assign({ className: clsx('flex justify-center items-center shrink-0', childWidth ? "w-".concat(childWidth, "px") : 'w-full') }, { children: child }), index));
                }) })), Children.count(children) > 1 && (_jsx("div", __assign({ className: clsx(controlsInsideContent && 'absolute', 'bottom-0 left-0 right-0', twMerge('pb-md-card-m md:pb-sm-gutter md:px-[168px]', controlsPadding)) }, { children: _jsx(Controls, { theme: theme, numItems: Children.count(children), currentIndex: selectedIndex, onSelectIndex: function (index) {
                        setSelectedIndex(index);
                        if (onSelectIndex) {
                            onSelectIndex(index);
                        }
                    } }) })))] })));
}
export default Carousel;
